import React from 'react';

export default function Card({ children, className = '' }) {
  // Check if a background color is already provided in the className
  const hasBg = className.includes('bg-');
  const baseClasses = `rounded-lg shadow-sm border border-tan p-6 ${hasBg ? '' : 'bg-white'}`;
  
  return (
    <div className={`${baseClasses} ${className}`}>
      {children}
    </div>
  );
}